import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { SubscriptionManagementComponent } from './components/subscription-management/subscription-management.component';
import { ContactComponent } from './components/contact/contact.component';
import { ImprintComponent } from './components/imprint/imprint.component';
import { TermsComponent } from './components/terms/terms.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { PaymentSuccessComponent } from './components/payment-success/payment-success.component';
import { PaymentCancelComponent } from './components/payment-cancel/payment-cancel.component';
import { SubscriptionExpiredPageComponent } from './components/subscription-expired-page/subscription-expired-page.component';
import { App } from './app';
import { authGuard } from './guards/auth.guard';
import { subscriptionGuard } from './guards/subscription.guard';
import { maintenanceGuard } from './guards/maintenance.guard';

export const routes: Routes = [
  // 🟢 PUBLIC ROUTES (immer offen, keine guards)
  { path: 'login', component: LoginComponent },
  { path: 'maintenance', component: MaintenanceComponent },
  { path: 'imprint', component: ImprintComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'terms', component: TermsComponent },

  // 🟡 MAINTENANCE-PROTECTED ROUTES
  { path: '', component: LandingPageComponent, canActivate: [maintenanceGuard] },
  { path: 'register', component: RegisterComponent, canActivate: [maintenanceGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [maintenanceGuard] },
  { path: 'verify-email', component: VerifyEmailComponent, canActivate: [maintenanceGuard] },
  { path: 'contact', component: ContactComponent, canActivate: [maintenanceGuard] },
  { path: 'payment/success', component: PaymentSuccessComponent, canActivate: [maintenanceGuard] },
  { path: 'payment/cancel', component: PaymentCancelComponent, canActivate: [maintenanceGuard] },
  { path: 'subscription-expired', component: SubscriptionExpiredPageComponent, canActivate: [maintenanceGuard] },

  // 🔴 PROTECTED ROUTES (auth + subscription)
  { path: 'app', component: App, canActivate: [maintenanceGuard, authGuard, subscriptionGuard] },
  { path: 'calculator', redirectTo: '/app', pathMatch: 'full' },
  { path: 'change-password', component: ChangePasswordComponent, canActivate: [maintenanceGuard, authGuard] },
  { path: 'subscription-management', component: SubscriptionManagementComponent, canActivate: [maintenanceGuard, authGuard] }
];
